export { NotificationInbox as default } from 'components/notification-inbox';
